import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-return-view-content',
    templateUrl: './return-view-content.component.html',
    standalone: false
})
export class ReturnViewContentComponent {
  @Input() returnData: any;
  @Input() currentLang = 'en';
  @Input() printActive = false;
  @Input() printSectionId = 'print_final_return_view';
  @Input() showDraftWatermark = false;
  @Input() showDetailsReturn = false;
  @Input() returnDetailsData: any;
}
